import { mapState } from "vuex";

var Suppliers = {
  created: function() {
    this.fetchWareHouses();
  },
  methods: {
    fetchWareHouses() {
      this.$store.dispatch("warehouse/fetchWarehouses");
    },
  },
  computed: {
    ...mapState("warehouse", ["warehouses"]),
  },
};

export default Suppliers;
